import { useMemo, useState } from "react";
import { Organization, useOrganizations } from "./rebuildBackendFetchHooks";

const DEFAULT_ORG: Organization = {
	organizationId: "default",
	organizationName: "Default",
};

export const TEST_ORGS: Organization[] = [
	{ organizationId: "0d31e4c9-39de-40a7-8507-d534a8d41997", organizationName: "Jack Test" },
	{ organizationId: "9dfe6912-4cc2-48fa-b93e-f372247fbef3", organizationName: "John Test" },
	{ organizationId: "b066f217-068a-47ec-bf30-0b0a1b4ce3ae", organizationName: "Amir Test" },
	{ organizationId: "275da48c-c720-4ef3-ba88-aaa7defd0dca", organizationName: "JL Test" },
	{ organizationId: "8baa614d-e403-4593-8cd3-45194af46e0f", organizationName: "JB Test" },
	{ organizationId: "3c734100-0643-4292-a241-fe2341a095f1", organizationName: "Scout Test" },
];

/**
 * Hook used anytime we want to display a drop-down of organizations that a user can select from. Always has the "default"
 * org as an option and then adds all organizations from the database to the list of options when those organizations are
 * fetched. Pass includeTestOrgs to also include test organizations in the list.
 */
export const useOrganizationSelect = ({ includeTestOrgs }: { includeTestOrgs?: boolean } = {}) => {
	const { data, loading } = useOrganizations();

	const organizations = useMemo(
		() => [...(data ?? []), ...(includeTestOrgs ? TEST_ORGS : []), DEFAULT_ORG],
		[data, includeTestOrgs],
	);

	const [selectedOrganization, _setSelectedOrganization] = useState<Organization>(DEFAULT_ORG);

	const setSelectedOrganization = (organization: Organization | undefined) => {
		if (organization) {
			_setSelectedOrganization(organization)
		} else {
			_setSelectedOrganization(DEFAULT_ORG)
		}
	}

	return { organizations, selectedOrganization, setSelectedOrganization, loading };
};
